<template>
    <el-dialog 
        :title="title === 1 ? '添加模板' : '编辑模板'" 
        :visible.sync="open" width="500px" 
        :close-on-click-modal="false" 
        :show-close="false"
        append-to-body>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="模板名称：" prop="name">
                        <el-input 
                            v-model.trim="form.name"
                            maxlength="10"
                            clearable
                            show-word-limit
                            placeholder="请输入模板名称"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm" v-loading="loading">确 定</el-button>
            <el-button @click="cancelForm">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    props: {
        title: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            open: false,
            loading: false,
            form: {
                id: null,
                name: null
            },
            rules: {
                name: [
                    { required: true, message: "模板名称不能为空", trigger: "blur" }
                ]
            }
        }
    },
    computed: {
        ...mapGetters(["templateInfo"])
    },
    methods: {
        ...mapActions(["AddTemplate", "GetTemplate", "GetTemplateInfo"]),
        // 初始化
        deal(form) {
            Object.keys(form).forEach(item => {
                this.form[item] = form[item]
            })
            this.open = true
        },
        // 提交
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.loading = true
                    this.AddTemplate(this.form).then(res =>{
                        if(res === 1 || res === 3){
                            // 需要刷新模板列表
                            this.GetTemplate().then(() => {
                                this.loading = false
                                if(res === 3 && this.templateInfo.id) {
                                    this.GetTemplateInfo(this.templateInfo)
                                }
                                this.open = false
                            })
                        } else if (res === 2) {
                            // 重新填写名称
                            this.loading = false
                        } else {
                            // 完成
                            this.loading = false
                            this.open = false 
                        }
                    }).catch(() => {
                        this.loading = false
                        this.open = false
                    })
                }
            });
        },
        // 取消
        cancelForm() {
            this.open = false
        }
    }
}
</script>

<style scoped>
.el-button--primary {
    background-color: #D3131A;
    border-color: #D3131A;
}
.el-button--primary:hover {
    background-color: #D3131A;
    border-color: #D3131A;
    opacity: 0.7;
}
.el-button--default {
    color: #D3131A;
}
.el-button--default:hover {
    background-color: rgb(245, 247, 250);
    border-color:#D3131A;
}
</style>